import { LoanTransactionDetailId } from '@/loan/enums/loan-transaction-detail-id';

export const LOAN_TRANSACTION_DETAIL_MAP: ReadonlyMap<
	LoanTransactionDetailId,
	string
> = new Map<LoanTransactionDetailId, string>([
	[LoanTransactionDetailId.PAYMENT_INTEREST, 'Paid to Interest'],
	[LoanTransactionDetailId.PAYMENT_PRINCIPAL, 'Paid to Principal'],
	[LoanTransactionDetailId.PAYMENT_FEES, 'Paid to Fees'],
	[LoanTransactionDetailId.PAYMENT_PRINCIPAL_ADDITIONAL, 'Paid to Additional Principal'],
	[LoanTransactionDetailId.PAYMENT_CHARGE_OFF_BALANCE, 'Paid to Charge Off Balance'],
	[LoanTransactionDetailId.UNPAID_INTEREST, 'Unpaid Interest'],
	[LoanTransactionDetailId.NON_LOAN_ITEMS, 'Non Loan Items'],
	[LoanTransactionDetailId.SCRA_INTEREST_REFUND, 'SCRA Interest Refund'],
	[LoanTransactionDetailId.OVERPAYMENT, 'Overpayment'],
]);
